/**
 * Richiesta AI — the AI Request Center. The workflow-heavy front door.
 * Source: Marko spec §2. coreBOS-A module: new on native BPM.
 *
 * The 7-step approval workflow lives in coreBOS-A native BPM — NOT a Flywheel child.
 * The kernel reads/projects the stato field only. On Approvata the linked ai_system is
 * created/updated by the coreBOS-A BPM step 8 (sync via connector, not a kernel concern).
 * Native per-step: approve / reject / Da integrare / comment / attachment / notify.
 *
 * Stato values: Bozza | Inviata | In validazione di funzione | In valutazione IT |
 *   In valutazione Privacy e Compliance | In valutazione Legal | In approvazione budget |
 *   In approvazione Comitato | Approvata | Respinta | Da integrare
 */
export const aiRequestDescriptor = {
    slug: 'ai_request',
    kind: 'document',
    label: { singular: 'Richiesta AI', plural: 'Richieste AI' },
    table: 'ai_portal_ai_request',
    idStrategy: 'sha256',
    fields: [
        { name: 'titolo_richiesta', type: 'text', label: 'Titolo richiesta', required: true },
        { name: 'finalita_uso', type: 'text', label: 'Finalità d\'uso', required: true },
        { name: 'tipologia_dati', type: 'text', label: 'Tipologia dati trattati', required: true },
        // Nessun dato personale | Dati personali comuni | Categorie particolari (Art. 9) | Biometrici | Clinici
        { name: 'utenti_previsti', type: 'number', label: 'Utenti previsti', required: true },
        { name: 'durata_prevista', type: 'text', label: 'Durata prevista', required: true },
        // Una tantum/PoC | Meno di 6 mesi | 6-12 mesi | Oltre 12 mesi
        { name: 'costo_stimato', type: 'decimal', label: 'Costo stimato' },
        { name: 'valutazione_privacy', type: 'text', label: 'Valutazione privacy e sicurezza', required: true },
        { name: 'categoria_rischio_proposta', type: 'text', label: 'Categoria di rischio proposta', required: true },
        // Inaccettabile | Alto | Limitato | Minimo
        { name: 'stato', type: 'text', label: 'Stato', required: true },
    ],
    relations: [
        { name: 'richiedente', kind: 'belongsTo', target: 'ai_user' },
        { name: 'sistema_ai', kind: 'belongsTo', target: 'ai_system' }, // optional ref to existing system
    ],
    behaviors: {
        ownership: true,
        audit: true,
        documents: true, // allegati obbligatori
        numbering: { prefix: 'REQ', seq: 'ai_portal_ai_request_no' },
        tenantScoped: true,
    },
    emits: [
        'ai_request.submitted',
        'ai_request.approved',
        'ai_request.rejected',
        'ai_request.returned',
    ],
    ui: { mode: 'generated', icon: 'AuditOutlined', navGroup: 'Governance', navOrder: 2 },
};
